export default "__VITE_ASSET__SJvS4PEH__"